
import { defineComponent, Ref, ref, computed } from 'vue'
import VesselMonitoringSingleHatch from "./VesselMonitoringSingleHatch.vue"

export default defineComponent({
  components: {
    VesselMonitoringSingleHatch
  },
  props: {
    vesselHatch: {},
  },
  computed: {
    vesselMonitoringData() {
      console.log(this.vesselHatch[0])
      return this.vesselHatch[0]
    }
  }
});

